import type * as Types from '../../../schemas/shopify/admin.types';

import { PickPageProductNodeFragmentDoc } from '../fragments/pickPageProduct.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type PickPageProductsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortKey?: Types.InputMaybe<Types.ProductSortKeys>;
  reverse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type PickPageProductsQueryResponse = {
  products: {
    edges: Array<
      Pick<Types.ProductEdge, 'cursor'> & {
        node: Pick<
          Types.Product,
          'id' | 'handle' | 'title' | 'status' | 'publishedAt' | 'templateSuffix'
        > & {
          featuredImage?: Types.Maybe<Pick<Types.Image, 'url'>>;
        };
      }
    >;
    pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
  };
};

export const PickPageProductsDocument = `
    query PickPageProducts($first: Int!, $after: String, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
  products(
    first: $first
    after: $after
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    edges {
      cursor
      node {
        ...PickPageProductNode
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PickPageProductNodeFragmentDoc}`;

export const usePickPageProductsQuery = <TData = PickPageProductsQueryResponse, TError = unknown>(
  variables: PickPageProductsQueryVariables,
  options?: UseQueryOptions<PickPageProductsQueryResponse, TError, TData>,
) => {
  return useQuery<PickPageProductsQueryResponse, TError, TData>(
    ['PickPageProducts', variables],
    appFetcherGemX<PickPageProductsQueryResponse, PickPageProductsQueryVariables>(
      PickPageProductsDocument,
      variables,
    ),
    options,
  );
};

usePickPageProductsQuery.getKey = (variables: PickPageProductsQueryVariables) => [
  'PickPageProducts',
  variables,
];
